(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SNCrypto", [], factory);
	else if(typeof exports === 'object')
		exports["SNCrypto"] = factory();
	else
		root["SNCrypto"] = factory();
})(self, () => {
return 